/**
 * AddCashPaymentServiceCtrl controller
 * Add/Edit Payment services
 */

import { PAYMENT_SYSTEM_TYPES } from 'app/core/constants'

// controller mixins
AddCashPaymentServiceCtrl.mixes = [
  ['m2mCtrlMixin', 'payment', 'currencies']
]

/**
 * AddCashPaymentServiceCtrl controller
 *
 * @class AddCashPaymentServiceCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:AddCashPaymentServiceCtrl
 */
/* @ngInject */
export default function AddCashPaymentServiceCtrl ($uibModalInstance, PaymentSystem, NetworkPaymentSystem, Location, payment, authSvc) {
  var vm = this

  // TODO: rewrite controller for cash payment (copied from AddPaymentServiceCtrl).

  /**
   * Has access
   *
   * @memberOf mwApp/settings.controller:AddCashPaymentServiceCtrl
   * @function
   */
  vm.hasAccess = function (access) {
    return authSvc.hasAccess(access)
  }

  /**
   * Payment system types
   *
   * @memberof mwApp/packages.controller:AddCashPaymentServiceCtrl
   * @name vm.payment_system_types
   * @type {Object}
   */
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  /**
   * PaymentSystem
   *
   * @memberof mwApp/settings.controller:AddCashPaymentServiceCtrl
   * @type {models.PaymentSystem}
   */
  vm.payment = payment

  /**
   * isNew flag
   *
   * @memberof mwApp/settings.controller:AddCashPaymentServiceCtrl
   * @type {Boolean}
   */
  vm.isNew = payment._isNew();

  /**
   * Currencies list
   *
   * @memberof mwApp/settings.controller:AddCashPaymentServiceCtrl
   * @name vm.currencies
   * @type {models.Currency[]}
   */
  // get currencies from extra
  ((payment instanceof NetworkPaymentSystem)
    ? NetworkPaymentSystem.loadExtra(NetworkPaymentSystem.extraFor(payment))
    : PaymentSystem.loadExtra(PaymentSystem.extraFor(payment))
  ).then(data => data.currencies || [])
    .except(payment.currencies) // remove currencies, already existed in payment
    .to(vm.currencies = [])

  /**
   * Create or edit payment, and close modal window afterwards
   *
   * @memberof mwApp/settings.controller:AddCashPaymentServiceCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    payment._save()
      .then(
        () => {
          payment.password = null // emptying password
          $uibModalInstance.close(payment)
        }
      ).finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/settings.controller:AddCashPaymentServiceCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  /**
   * Enable locations
   */
  vm.enableLocation = () => {
    if (vm.payment.locationEnabled) {
      !vm.payment.locations.length && vm.payment.locations.push(new Location({ id: null, name: '' })) // Note: default value
    } else {
      vm.payment.locations = []
      vm.payment.locationRequired = false
    }
  }

  /**
   * Add new location field
   *
   */
  vm.addLocation = (form) => {
    form.$setDirty()
    vm.payment.locations.push(new Location({ id: null, name: '' }))
  }

  /**
   * Remove element from locations
   *
   * @param index
   */
  vm.removeLocation = (index, form) => {
    form.$setDirty()
    vm.payment.locations.splice(index, 1)
  }
}
